import { useMediaQuery } from 'react-responsive';

export const MOBILE_WIDTH_BREAKPOINT = 599;
export const TABLET_WIDTH_BREAKPOINT = 1199;

export const useIsMobile = (): boolean =>
  useMediaQuery({ maxWidth: MOBILE_WIDTH_BREAKPOINT });
export const useIsTablet = (): boolean =>
  useMediaQuery({ minWidth: 600, maxWidth: TABLET_WIDTH_BREAKPOINT });
export const useIsDesktop = (): boolean => useMediaQuery({ minWidth: 1200 });
